/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-24 13:40:38
 * @LastEditTime: 2025-08-04 11:59:13
 * @LastEditors: taoyuan taoyuan@originqc.com
 */
import React from 'react'
import { useNavigate } from 'react-router-dom';
import moreActive from './imgs/more-active.svg'
import { openCustomerService } from '@/utils';
import ServiceIds from '../service-ids';

import './index.scss';

interface ICard { 
  width?: number,
  height?: number,
  albumPics?: string,
  name?: string,
  serviceIds?: string,
  price?: number,
  type?: string,
  goodsData?: any,
  id?: number,
  is_new?: 0 | 1,  //0 不是新0，是新1
  is_list: string,//home 首页，不展示new ,list 列表页，is_new=1展示new,,like,猜你喜欢
  tabId?: number,//有children tab菜单才有tabId
  data?: any,
  productSn:string,
  is_title?: boolean,
  productType?:number,
  unit?:string,
}


const CustomCard: React.FC<ICard> = (props) => {

  const navigate = useNavigate();
  const {
    width = 237,
    height = 300,
    albumPics,
    name,
    serviceIds,
    price=null,
    type = null,//coming代表展示comming soon,more最后一个card分一半，浏览更多，
    id,
    is_list,
    productSn,
    is_title,
    productType,
    unit
   
  } = props;

  const handleGoSearch = (event: React.MouseEvent<HTMLDivElement>) => { 
    event.stopPropagation(); // 阻止事件冒泡
    if (type === 'more') { 
 
      navigate(`/shop/search?categoryId=${props?.tabId}&parentName=${props?.data?.name}`)
    }
   
  }
  const typeData = (type:string) => {
    return (
      <>
        {type === 'coming' && <div className='coming'><div><p >敬请期待</p><p>COMING SOON</p></div></div>}
        {type === 'more' && (props?.goodsData.length > 8 || props.goodsData.length === 8 ? <div className='half-content' onClick={ getHrefDetail}>
          <div className='half-card' style={{width:width}}>
            <img src={albumPics} alt="卡片" />
          <div>
          <p className='half-card-title'>{props?.goodsData[7].name}</p>
            <p className='half-card-price'>￥{price}</p>
          </div>
        </div>
          <div className="half-card-more" style={{width:width}}  onClick={(event) => handleGoSearch(event)}>
            <span>浏览更多<img src={ moreActive}  alt='more'/></span>
        </div>
        </div>:<div className="half-card-more"   style={{marginTop:'0',width:width}} onClick={(event) => handleGoSearch(event)}>
            <span>浏览更多<img src={ moreActive}  alt='more'/></span>
        </div>)}
      </>
      
    )
  }
  const getDetail = () => { 
    if (!type) { 
      window.open(`/detail?productSn=${productSn}`);
    }
  }
  const getHrefDetail = () => { 
    window.open(`/detail?productSn=${productSn}`);
    
  }
  const handleService = (event:any) => { 
    event.stopPropagation();
    openCustomerService()
  }

  const unitType:any = {
    3:'月',
    5:'年',
    0:'永久授权'
  }

  return (
    <div className='card-container'
      style={{
        width: width,
        height: height,
        background: type === 'more' ? 'transparent' : '#fff',
        paddingTop: type === 'more' ? '0' : '20px'
      }}
      onClick={ getDetail}
    >
      {type ?
        typeData(type)
        // <div className='coming'><div><p >敬请期待</p><p>COMING SOON</p></div></div>
        : <><img src={albumPics} alt="卡片" className='card-img' style={{maxWidth:'100%'}} />
          <h3 className={`${is_list==='list'?'title add-margin':'title'} ${is_list==='list'&&props.is_new === 1 ? 'new-title-style' : ''}` }>
            {props?.is_new===1 &&is_list==='list'&& <span className='new'>NEW</span>}
            {name}
          </h3>
          {
            !is_title &&
            <p className={`${is_list === 'list' ? 'sub-title add-margin-title' : 'sub-title'} ${is_list === 'list' && props.is_new === 1 ? 'new-title-style' : ''}`}>
                <ServiceIds serviceIds={serviceIds??''} />
              </p>
          }
          {price ? <p className='pirce'>￥{price}{productType === 3 && unit ? <>{` / ${unitType[unit!]}` }</> : ''}</p> : <p className='pirce' onClick={(event)=>handleService(event)}>立即咨询</p>} </>}
    </div>
  )
}

export default CustomCard;